import React from 'react';

import { Card, CardHeader } from '@mui/material';

import { TngGrid } from '../../../../components/common';

const ChangePassword = () => {
  return (
    <TngGrid container className="change_password_container" marginBottom="100px">
      <TngGrid item xs={10} md={10} lg={12}>
        <Card className="chnage_password_card">
          <CardHeader component="h5" title="Change Password" />
        </Card>
      </TngGrid>
    </TngGrid>
  );
};

export default ChangePassword;
